import Path from "@core/FileProvider/Path/Path";
import { DialogErrorHeader } from "@ext/errorHandlers/client/components/DialogErrorHeader";
import DefaultError from "@ext/errorHandlers/logic/DefaultError";
import type { GetErrorComponentProps } from "@ext/errorHandlers/logic/GetErrorComponent";
import t from "@ext/localization/locale/translate";
import CodeBlock from "@ext/markdown/elements/codeBlockLowlight/render/component/CodeBlock";
import Note, { NoteType } from "@ext/markdown/elements/note/render/component/Note";
import { DialogBody, DialogFooterTemplate } from "@ui-kit/Dialog";

export const PDF_SAVE_FAILED = "pdf-save-failed";

export const pdfSaveFailed = (path: string, reason: string, chooseAnotherLocation: () => void) => {
	const name = new Path(path).nameWithExtension;
	return new DefaultError(
		t("export.pdf.saveError.diagnosis").replace("{name}", name),
		new Error(reason),
		{ errorCode: PDF_SAVE_FAILED, name, chooseAnotherLocation },
		false,
		t("export.pdf.saveError.title"),
	);
};

const PdfSaveFailedError = ({ error, onCancelClick }: GetErrorComponentProps) => {
	const chooseAnotherLocation = () => {
		onCancelClick();
		error.props.chooseAnotherLocation();
	};
	const [lead, tail] = t("export.pdf.saveError.diagnosis").split("{name}");

	return (
		<>
			<DialogErrorHeader error={error} />
			<DialogBody>
				<div className="article !bg-transparent flex flex-col gap-4">
					<span>
						{lead}
						<code>{error.props.name}</code>
						{tail}
					</span>
					<span>{t("export.pdf.saveError.recipe")}</span>
					<Note collapsed title={t("technical-details")} type={NoteType.hotfixes}>
						<CodeBlock>{error.cause.message}</CodeBlock>
					</Note>
				</div>
			</DialogBody>
			<DialogFooterTemplate
				primaryButton={t("export.pdf.saveError.chooseAnotherLocation")}
				primaryButtonProps={{ onClick: chooseAnotherLocation }}
				secondaryButton={t("close")}
				secondaryButtonProps={{ onClick: onCancelClick, variant: "outline" }}
			/>
		</>
	);
};

export default PdfSaveFailedError;
